"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDebugParam = void 0;
var win_1 = require("../utils/win");
exports.hasDebugParam = function () {
    var _a;
    return typeof URLSearchParams !== 'undefined' &&
        new URLSearchParams((_a = win_1.win === null || win_1.win === void 0 ? void 0 : win_1.win.location) === null || _a === void 0 ? void 0 : _a.search).has('debug');
};
//# sourceMappingURL=hasDebugParam.js.map